class LocalStorage {
    static setAuthenthicationToken(access_token) {
        localStorage.setItem("access_token", access_token);
    }

    static getAuthenticationToken() {
        return localStorage.getItem("access_token");
    }

    static setRefreshToken(refresh_token) {
        localStorage.setItem("refresh_token", refresh_token);
    }

    static getRefreshToken() {
        return localStorage.getItem("refresh_token");
    }

    static setCurrentUser(user) {
        if (user) {
            let strValue = JSON.stringify(user);
            localStorage.setItem("current_user", strValue);
        }
    }

    static getCurrentUser() {
        let strValue = localStorage.getItem("current_user");
        const user = JSON.parse(strValue);

        return user;
    }

    static setSSOFlag(flag) {
        localStorage.setItem("sso_auth", flag);
    }

    static getSSOFlag() {
        return localStorage.getItem("sso_auth");
    }

    static removeSSOFlag() {
        localStorage.removeItem("sso_auth");
    }

    static setEnterpriseRegistrationContext(plan, projectName, currency) {
        const context = {
            plan: plan,
            projectName: projectName,
            currency: currency || 'eur'
        };
        localStorage.setItem("enterprise_registration_context", JSON.stringify(context));
    }

    static getEnterpriseRegistrationContext() {
        const contextStr = localStorage.getItem("enterprise_registration_context");
        if (contextStr) {
            return JSON.parse(contextStr);
        }
        return null;
    }

    static removeEnterpriseRegistrationContext() {
        localStorage.removeItem("enterprise_registration_context");
    }

    static setQuickStartDismissed(projectId, value = true) {
        const dismissed = JSON.parse(localStorage.getItem("quickstart_dismissed") || "{}");
        dismissed[projectId] = value;
        localStorage.setItem("quickstart_dismissed", JSON.stringify(dismissed));
    }

    static getQuickStartDismissed(projectId) {
        const dismissed = JSON.parse(localStorage.getItem("quickstart_dismissed") || "{}");
        return Boolean(dismissed[projectId]);
    }

    static setBridgeOptedOut(value) {
        localStorage.setItem("bridge_opted_out", value);
    }

    static getBridgeOptedOut() {
        return localStorage.getItem("bridge_opted_out") === "true";
    }

    static removeBridgeOptedOut() {
        localStorage.removeItem("bridge_opted_out");
    }

    static logoutUser() {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("current_user");
        localStorage.removeItem("sso_auth");
        localStorage.removeItem("enterprise_registration_context");
        localStorage.removeItem("quickstart_dismissed");
        localStorage.setItem("bridge_opted_out", "true");
    }

}

export default LocalStorage;
